import { keepPreviousData } from '@tanstack/react-query';

import { Environment } from '@playq/octopus-common';
import { GenericFailure, ServicesCompanyID } from '@playq/services-shared';
import { IdentityId, PrivateIdentity } from '@playq/services-fingerprint';

import { IUseQueryOptionsExtended, useEitherQuery } from '/api/service-hooks';
import { services2 } from '/api/services2';

import { playerLookupKeys } from './constants';

export const useRetrieveIdentityProfile = (
  { companyID, identityId, env }: { companyID?: ServicesCompanyID; identityId: IdentityId; env: Environment },
  options?: IUseQueryOptionsExtended<PrivateIdentity | undefined, GenericFailure | Error>
) => {
  return useEitherQuery(
    playerLookupKeys.identityProfile(identityId, env, companyID),
    () => {
      if (companyID) {
        return services2.fingerprintLookupService.retrieveProfile(companyID, identityId, env);
      }
    },
    {
      placeholderData: keepPreviousData,
      ...options,
    }
  );
};
